import { LandLineListInterface } from '../../models/land-line-list.interface';

export interface SelectedLandLineInterfaceState {
  line: LandLineListInterface;
}

export const initialSelectedLandLineState: SelectedLandLineInterfaceState = {
  line: null
};
